export class PlateCarConfig {
  public name: string;
  public config: {
    imageInfo: {
      path: string;
    };
  };
}

export class PlateViewerConfig {
  public id: number;
  public carName: string;
  public config: string;
  public imageName: string;
  public groupMain: boolean;
  public groupId: string;
  public image: string;
  public active: boolean;

  public builtConfig: PlateCarConfig;

  constructor(_?: {
    id: number;
    carName: string;
    config: string;
    imageName: string;
    groupId: string;
    active: boolean;
  }) {
    if (_ == null) return;
    this.id = _.id;
    this.carName = _.carName;
    this.config = _.config;
    this.imageName = _.imageName;
    this.groupId = _.groupId;
    this.active = _.active;

    this.builtConfig = this.getConfig() as PlateCarConfig;
  }

  public getConfig(): PlateCarConfig {
    return JSON.parse(this.config);
  }
}
